import LoginModal from './LoginModal'

export { LoginModal }
export default LoginModal
